import { styled } from 'styled-components'

import { SegmentCard } from '../Segment/Segment.Styled'

export const StyledContainer = styled(SegmentCard)`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  gap: 20px;
`
